import { Router } from 'director/build/director'

// Routes are configured in router-conf.js - configuring them here would create circular
// dependencies with any modules that use the router.

export const router = Router()
